// Error Messages
export const NO_ACH_RELATIONSHIP = 'This account does not have an ACH relationship. ACH Transfer is not available.'
export const ACCOUNT_RESTRICTION_WARNING =
  'Transfer requests are not allowed for some types of restrictions. Your request may be rejected.'
export const ERROR_RETRIEVING_DATA = 'There was an error retrieving the account information. Please try again.'
export const NO_FIRM_ACCOUNT = 'Reward journals can only be issued from a firm account. Please check your account.'
export const THIRD_PARTY_TRANSFER = 'Third-party transfer: Verify a Letter of Authorization is on file.'
export const ACCOUNT_NOT_FOUND = 'Account not found. Try again.'
//Toast Messages
export const SERVICE_UNAVAILABLE_TOAST = 'Sorry, this service is temporarily unavailable. The request failed.'
export const TOTAL_TRANSFER_SUCCESS_TOAST =
  'Your transfer request has been submitted for processing. Note: removing all assets does not automatically close the account.'
export const TRANSFER_SUCCESS_TOAST = 'Your transfer request has been submitted for processing.'
